var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-main com-width-1400 com-margin-auto"},[_vm._ssrNode("<div class=\"content\">"+(_vm._s(_vm.info))+"</div> <div></div>")])
}
var staticRenderFns = []

export { render, staticRenderFns }